module.exports = __webpack_public_path__ + "assets/img/main-logo_mobile-langfang.2a06b7c7.png";